import axios from 'axios';
import { API_BASE_URLS } from './config.mjs'; // Ensure correct import
import { store } from '../store/store.js'; 
import {authenticateActions} from "../store/store.js";
 import { adminServiceAPI as napidauthServiceAPI  } from '../api/axiosInstance.js'

napidauthServiceAPI.interceptors.response.use(
  (response) => response, // If success, just return the response
    (error) => {
      const message = error?.response?.data?.message;
  
      if (
        message === "Invalid or expired access token" ||
        message === "Invalid or Missing AccessToken"
      ) {
        store.dispatch(authenticateActions.logout());
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
      }
  
      // Always return or reject the error to keep the chain working
      return Promise.reject(error);
    }
  );

 
const proxyRequest = async (service, endpoint, method, data) => {
    const targetURL = `${API_BASE_URLS[service]}${endpoint}`;

    try {
      if (data instanceof FormData) {
        if (!data.has('endpoint')) {
            console.log(endpoint)
            data.append('endpoint', endpoint); // Add endpoint to FormData if not already included
          }
        console.log("Sending FormData Request...");
        for (let pair of data.entries()) {
          console.log(pair[0], pair[1]); // Debugging FormData contents
        }
        const response = await napidauthServiceAPI({
          method,
          url: '/napidauth',
          data, // Directly send FormData
          headers: {
            "Content-Type": "multipart/form-data", // Axios sets correct boundary
          },
        });
        return response.data;
      } else {
        const response = await napidauthServiceAPI({
          method,
          url: targetURL,
          data, // Send JSON data
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("response",response.data)
        return response.data;
      }
    } catch (error) {
      console.log( error.response.data.message)
       if (
         error.response.data.statusCode === "FAILED" &&
         error.response.data.message === "Invalid or expired access token"
     ) {
       window.location.href = "/login"; // Redirect to login page
     }
   
     return error.response.data;
   }
  };
 
  export const NapidAuthAPI = {
    getUserDetails: async (accessToken) => {
      const endpoint = "/napidauth/virtualid/v1/user";
      const formData = new FormData();
      formData.append("accessToken", accessToken);
 
      console.log("FormData being sent:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]); // Debugging FormData
      }
 
      return proxyRequest("NAPID_AUTH_SERVICE", endpoint, "POST", formData);
    },
 
    regenerateAccessToken: async (refreshToken) => {
      console.log("regenerateAccessToken",refreshToken)
      const endpoint = "/napidauth/virtualid/v1/refreshtoken";
      
      const trimmedToken = refreshToken.trim();
 
      const formData = new FormData();
      formData.append('refreshToken', trimmedToken);
 
      console.log("FormData being sent:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]); 
      }
 
      return proxyRequest("NAPID_AUTH_SERVICE", endpoint, "POST", formData);
    },
 
    logoutUser: async (accessToken) => {
      const endpoint = "/napidauth/virtualid/v1/user/logout";
      const formData = new FormData();
      formData.append('accessToken', accessToken);
    
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]); // Debugging FormData
        }
        
      return proxyRequest("NAPID_AUTH_SERVICE", endpoint, "POST",  formData );
    },
  };
 
  export default NapidAuthAPI;